@if (typeMessage) {
  <span>
    <span class="badge bg-info">{{ typeMessage | translate }}</span>
  </span>
}
